import { INITIAL_FIELD_STATE } from "./app.constants"

export const VALIDATION_MSGS = {
    REQUIRED: "Please enter value here",
    PASSWORD_REQUIRED: "Please enter password",
    INVALID_NAME: "Please enter valid value. It may only contain letters,numbers, spaces, and special characters(+,@,-,_,.,')",
    INVALID_PASSWORD: "Please enter valid password. It must contain minimum eight characters, at least one letter, one number and one special characters",
    INVALID_CONFIRM_PASSWORD: "Password and confirm password do not match",
    INVALID_CONTACT_NUMBER: "Please enter valid contact number. It must contain 10 digits only",
    INVALID_EMAIL: "Please enter valid email-address",
    FREE_EMAIL_NOT_ALLOWED: "Only Business Email Address is allowed",
    INVALID_OTP: "Please Enter valid otp of 6 digits"
}


export const  REGISTER_INITIAL_STATE = {
    firstname: {...INITIAL_FIELD_STATE, errors: [VALIDATION_MSGS.REQUIRED]},
    lastname: {...INITIAL_FIELD_STATE, errors: [VALIDATION_MSGS.REQUIRED]},
    password: {...INITIAL_FIELD_STATE, errors: [VALIDATION_MSGS.REQUIRED]},
    confirmPassword: {...INITIAL_FIELD_STATE, errors: [VALIDATION_MSGS.REQUIRED]},
    contactNumber: {...INITIAL_FIELD_STATE, errors: [VALIDATION_MSGS.REQUIRED]},
    emailAddress: {...INITIAL_FIELD_STATE, errors: [VALIDATION_MSGS.REQUIRED]},
    organization: {...INITIAL_FIELD_STATE, errors: [VALIDATION_MSGS.REQUIRED]},
    username: {...INITIAL_FIELD_STATE, errors: [VALIDATION_MSGS.REQUIRED]}
}

export const LOGIN_VALIDATION = {
    NAME: /^([A-Za-z0-9]+[.'@+_-]?)*$/ ,
    CONTACT_NUMBER_CHANGE: /^[0-9]*$/,
    CONTACT_NUMBER: /^[0-9]{10}$/,
    EMAIL: /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[\w-]+(\.[\w-]+)*(\.[\w-]{2,})$/,
    INVALID_EMAIL: /^([\w-.]+@(?!gmail\.com)(?!yahoo\.com)(?!hotmail\.com)(?!mail\.ru)(?!yandex\.ru)(?!mail\.com)([\w-]+.)+[\w-]{2,4})?$/,
    OTP: /^[0-9]{6}$/,
    PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
  };